import { render, staticRenderFns } from "./NewChapter.vue?vue&type=template&id=54427c2a&scoped=true"
import script from "./NewChapter.vue?vue&type=script&lang=js"
export * from "./NewChapter.vue?vue&type=script&lang=js"
import style0 from "./NewChapter.vue?vue&type=style&index=0&id=54427c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54427c2a",
  null
  
)

export default component.exports